import { HIDE_MAP } from 'actiontypes/map';
import { Dispatch } from 'redux';

export default function hideMap() {
  return (dispatch: Dispatch) => dispatch({ type: HIDE_MAP });
}